var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.66667L10 12.1667L16.6667 5.5",
    stroke: "#EF5E23",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.5V15.5C16.6667 15.942 16.4911 16.366 16.1785 16.6785C15.8659 16.9911 15.442 17.1667 15 17.1667H4.99999C4.55797 17.1667 4.13404 16.9911 3.82148 16.6785C3.50892 16.366 3.33333 15.942 3.33333 15.5V5.50001C3.33333 5.05798 3.50892 4.63406 3.82148 4.3215C4.13404 4.00894 4.55797 3.83334 4.99999 3.83334H12.5",
    stroke: "#EF5E23",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2e66c6295bca63a4e11bd6cabff80e08.svg";
export { ForwardRef as ReactComponent };